interface MetaTag {
  name: string
  content: string
}

interface LinkTag {
  rel: string
  href: string
  as?: string
  crossOrigin?: string
  fetchPriority?: 'high' | 'low' | 'auto'
}

/**
 * MOCKUP OFICIAL del producto (tapa + celulares + fichas + libro abierto).
 * Es el elemento LCP del hero y se reutiliza, más chico, en la oferta.
 * No aplicar filtros, recortes ni textos encima: se muestra siempre completo
 * y con su proporción original.
 */
export const HERO_IMAGE_URL =
  'https://cdn.magicpatterns.com/uploads/eYdqCwUsDcvL1h1uabzQTR/Mockup.png'

/** El bloque de oferta muestra el mismo mockup oficial, en menor tamaño. */
export const BUNDLE_IMAGE_URL = HERO_IMAGE_URL

/** Comerciante respondiendo una consulta por WhatsApp (para quién es / cierre). */
export const AUDIENCE_IMAGE_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/8b3a74f2-2f91-4f17-bbe9-ae16a0b6fb5b.jpg'

const PAGE_TITLE =
  '100 Scripts de WhatsApp para Cerrar Más Ventas — mensajes listos para copiar y enviar'

const META_TAGS: MetaTag[] = [
  {
    name: 'description',
    content:
      '100 Scripts de WhatsApp para Cerrar Más Ventas: mensajes listos para copiar y enviar, organizados en 6 etapas — apertura, cualificación, presentación, precio, seguimiento y cierre. Convertí consultas en ventas mientras atendés.',
  },
]

const LINK_TAGS: LinkTag[] = [
  // Warm up the font + image origins before the CSS/image requests are made.
  { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
  { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' },
  { rel: 'preconnect', href: 'https://cdn.magicpatterns.com' },
  // Discover the LCP image as early as possible, at high priority.
  { rel: 'preload', href: HERO_IMAGE_URL, as: 'image', fetchPriority: 'high' },
]

/**
 * Inserts global <meta> and resource-hint <link> tags into <head> once.
 * Existing tags are never duplicated.
 */
export function initHeadMeta(): void {
  if (typeof document === 'undefined') return

  document.title = PAGE_TITLE

  META_TAGS.forEach(({ name, content }) => {
    if (document.querySelector(`meta[name="${name}"]`)) return

    const meta = document.createElement('meta')
    meta.name = name
    meta.content = content
    document.head.appendChild(meta)
  })

  LINK_TAGS.forEach(({ rel, href, as, crossOrigin, fetchPriority }) => {
    if (document.querySelector(`link[rel="${rel}"][href="${href}"]`)) return

    const link = document.createElement('link')
    link.rel = rel
    link.href = href
    if (as) link.as = as
    if (crossOrigin) link.crossOrigin = crossOrigin
    if (fetchPriority) link.setAttribute('fetchpriority', fetchPriority)
    document.head.appendChild(link)
  })
}
